module.exports = ".swap-link{\r\n    transition: all 0.3s;\r\n}\r\n\r\n.swap-link:hover{\r\n    color: cornflowerblue;\r\n}"